<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Checkbox, Input, Text, toast } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	let id = real_id(device.id),
		settings = readDeviceSettings(id),
		showFavorites = settings?.ui?.show_favourites,
		cacheShowFavorites = settings?.ui?.show_favourites,
		showMainSensorGraph = settings?.ui?.show_main_sensor_graph,
		cacheShowMainSensorGraph = settings?.ui?.show_main_sensor_graph,
		useF = settings?.ui?.use_F,
		cacheUseF = settings?.ui?.use_F,
		loading = false;

	const sendRequest = async () => {
		if (
			cacheShowFavorites === showFavorites &&
			cacheShowMainSensorGraph === showMainSensorGraph &&
			cacheUseF === useF
		) {
			return;
		}
		loading = true;

		const params = {
			id: device.channel,
			config: {
				show_favourites: showFavorites,
				show_main_sensor_graph: showMainSensorGraph,
				use_F: useF,
			},
		};

		const res: SettingRequest = await gen2Request(device, `ui.SetConfig`, params);
		const response = await onSettingsResponse(res, device);
		if (response) {
			settings.ui.show_favorites = showFavorites;
			settings.ui.show_main_sensor_graph = showMainSensorGraph;
			settings.ui.use_F = useF;
			devices_settings.update_devices_settings(id, settings);

			cacheShowFavorites = showFavorites;
			cacheShowMainSensorGraph = showMainSensorGraph;
			cacheUseF = useF;
		} else {
			showFavorites = cacheShowFavorites;
			showMainSensorGraph = cacheShowMainSensorGraph;
			useF = cacheUseF;
		}
		loading = false;
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({ onClick: sendRequest, loading, disabled: loading });
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Checkbox
	checked={showFavorites}
	size="m"
	class="mt-m"
	value={showFavorites}
	on:click={() => (showFavorites = !showFavorites)}
	id="checkbox-k1jmi3o">{$format('show_favorites', { default: 'Show favorites' })}</Checkbox
>
<Checkbox
	checked={showMainSensorGraph}
	size="m"
	class="mt-m"
	value={showMainSensorGraph}
	on:click={() => (showMainSensorGraph = !showMainSensorGraph)}
	id="checkbox-o9ombmb">{$format('show_sensor_graph', { default: 'Show sensor graph' })}</Checkbox
>
<Checkbox
	checked={useF}
	size="m"
	class="mt-m"
	value={useF}
	on:click={() => (useF = !useF)}
	id="checkbox-f06l22g"
	>{$format('use_f_desc', {
		default: 'Use Fahrenheit instead of Celsius',
	})}</Checkbox
>
{#if !$showNewLayout}
	<Button class="mt-s" {loading} size="m" width="full" on:click={sendRequest}
		>{$format('button_save')}</Button
	>
{/if}
